import { useState, useEffect } from 'react';
import useOrgStore from '../store/zustand/useOrgStore';
import fetchCategories from '../utils/fetchFunctions/fetchCategories';
import { StageCategoryPartial } from '../_types/types.type';

export const useCategories = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const setCategories = useOrgStore((state) => state.setCategories);
  const categories: StageCategoryPartial[] = useOrgStore(
    (state) => state.categories
  );

  const fetchAndStoreCategories = async () => {
    try {
      setIsLoading(true);
      const fetchedCategories = await fetchCategories();
      // console.log(
      //   '🚀 ~ fetchAndStoreCategories ~ fetchedCategories:',
      //   fetchedCategories
      // );
      setCategories(fetchedCategories);
      setIsLoading(false);
    } catch (err) {
      setError(JSON.stringify(err));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (categories.length > 0) return;
    fetchAndStoreCategories();
    // @ts-ignore
  }, [global.me.orgID]);

  return {
    isLoading,
    error,
    categories,
    fetchCategories: fetchAndStoreCategories,
  };
};
